import { getPipelineCost } from './pipelineCost';

// A development budget is not the user's quote or won revenue.
export function trackedStageValue(row) {
  const stage = row.pipeline_stage || 'watching';
  const amount = stage === 'won' ? row.won_amount : stage === 'quoted' ? row.quoted_amount : getPipelineCost(row);
  const value = Number(amount);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

export function summariseTrackedPipeline(rows = [], now = Date.now(), periodDays = 90) {
  const stages = {};
  let wonCount = 0, lostCount = 0, wonValue = 0;
  const due = [];
  const cutoff = now - periodDays * 86400000;
  for (const row of rows) {
    const stage = row.pipeline_stage || 'watching';
    if (!stages[stage]) stages[stage] = { count: 0, value: 0 };
    stages[stage].count += 1;
    stages[stage].value += trackedStageValue(row);
    const changedAt = Date.parse(row.pipeline_updated_at);
    if (changedAt >= cutoff && changedAt <= now) {
      if (stage === 'won') { wonCount += 1; wonValue += trackedStageValue(row); }
      if (stage === 'lost') lostCount += 1;
    }
    if (!['won', 'lost', 'not_relevant'].includes(stage) && row.next_follow_up_at && Date.parse(row.next_follow_up_at) <= now) {
      due.push({ ...row, overdue: Date.parse(row.next_follow_up_at) < now });
    }
  }
  return { tracked_count: rows.length, period_days: periodDays, stages,
    quoted_open_count: stages.quoted?.count || 0, quoted_open_value: stages.quoted?.value || 0,
    won_count: wonCount, won_value: wonValue,
    win_rate: wonCount + lostCount ? Math.round(100 * wonCount / (wonCount + lostCount)) : null,
    due_follow_ups: due.sort((a,b) => Date.parse(a.next_follow_up_at) - Date.parse(b.next_follow_up_at)) };
}
